export const LOAD = 'LOAD';
export const TWOFA = 'TWOFA';
export const ID = 'ID';
export const CLIENT_REF = 'CLIENT_REF';
export const TOKEN = 'TOKEN';
export const COLOR = 'COLOR';
export const LOGO_LINK = 'LOGO_LINK';
export const STYLIZED = 'STYLIZED';
export const PARTNER = 'PARTNER';
export const ACCOUNT_ID = 'ACCOUNT_ID';
export const EMAIL = 'EMAIL';
export const SUCCESS_STATUS = 'SUCCESS_STATUS';
export const ERROR_STATUS = 'ERROR_STATUS';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const GET_CREDENCIALS_RESPONSE = 'GET_CREDENCIALS_RESPONSE';
